import { useLazyQuery } from '@apollo/client/react';
import pDebounce from 'p-debounce';
import { useEffect } from 'react';

import type { EntitledAccountsPayload } from '@zen/graphql/types.generated';

import {
  GetEntitledAccountsFiltersDocument,
  type GetEntitledAccountsFiltersQueryResult,
  type GetEntitledAccountsFiltersQueryVariables
} from '../AccountDetails/AccountLocations/AccountLocationsFilters/graphql';

type SearchEntitledAccountWithManagedArguments = {
  accountId: string;
};

export const useSearchEntitledWithManagedAccount = (args: SearchEntitledAccountWithManagedArguments) => {
  const { accountId } = args;
  const [fetchEntitledWithManagedAccounts, { data, loading, error }] = useLazyQuery<
    GetEntitledAccountsFiltersQueryResult,
    GetEntitledAccountsFiltersQueryVariables
  >(GetEntitledAccountsFiltersDocument, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    fetchEntitledWithManagedAccounts({
      variables: {
        accountId,
        searchQuery: ''
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (query: string): void => {
    if (query) {
      fetchEntitledWithManagedAccounts({
        variables: {
          accountId,
          searchQuery: query
        }
      });
    }
  };

  const debounceDelay: number = 300;
  const debouncedHandleInputChange = pDebounce(handleInputChange, debounceDelay);

  const entitledAccounts: EntitledAccountsPayload = data?.entitledAccounts as EntitledAccountsPayload;

  return {
    entitledAccounts,
    loading,
    error,
    onSearch: debouncedHandleInputChange
  };
};
